const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const supportive=s=>String(s||'').toUpperCase()==='SUPPORTIVE';

export function deriveTenXResearchEvidence(bundle={}){
  const price=N(bundle?.market?.price);
  const shares=N(bundle?.secFinancials?.metrics?.sharesOutstanding);
  const marketCap=price!=null&&shares!=null&&price>0&&shares>0?price*shares:null;
  const revenueGrowth=N(bundle?.consensus?.snapshot?.consensus_revenue_growth_pct);
  const fcf=N(bundle?.secFinancials?.metrics?.freeCashFlowAnnual);
  const qualitySignals=bundle?.companyQualityEvidence?.signals||{};
  const qualitySupport=Object.values(qualitySignals).filter(x=>supportive(x?.state)).length;
  const qualityObserved=Object.values(qualitySignals).filter(x=>String(x?.state||'MISSING')!=='MISSING').length;
  const insiderState=String(bundle?.insiderEvidence?.state||'MISSING').toUpperCase();
  const analystCount=N(bundle?.consensus?.snapshot?.consensus_analyst_count);

  const scale=marketCap==null?'MISSING':marketCap<=1e9?'STRONG_ROOM':marketCap<=5e9?'ROOM':marketCap<=15e9?'LIMITED_ROOM':'SCALE_HEAVY';
  const growth=revenueGrowth==null?'MISSING':revenueGrowth>=30?'STRONG':revenueGrowth>=15?'SUPPORTIVE':revenueGrowth>=0?'LOW':'CONTRACTING';
  const cash=fcf==null?'MISSING':fcf>0?'SUPPORTIVE':'CAUTION';
  const quality=qualityObserved<3?'MISSING':qualitySupport>=4?'STRONG':qualitySupport>=3?'SUPPORTIVE':qualitySupport>=1?'MIXED':'CAUTION';
  const insider=insiderState==='CLUSTER_CODE_P'?'CLUSTER_SUPPORT':insiderState==='RECENT_CODE_P'?'RECENT_SUPPORT':insiderState==='OLDER_CODE_P'?'OLDER_SUPPORT':insiderState==='NO_RECENT_CODE_P'?'NEUTRAL':'MISSING';

  const supportCount=[cash==='SUPPORTIVE',quality==='STRONG'||quality==='SUPPORTIVE',insider==='CLUSTER_SUPPORT'||insider==='RECENT_SUPPORT'].filter(Boolean).length;
  const missingCore=scale==='MISSING'||growth==='MISSING';
  let state='LOW_10X_FIT';
  if(missingCore)state='REVIEW';
  else if(['STRONG_ROOM','ROOM'].includes(scale)&&['STRONG','SUPPORTIVE'].includes(growth)&&supportCount>=2)state='HIGH_10X_RESEARCH_PRIORITY';
  else if(['STRONG_ROOM','ROOM','LIMITED_ROOM'].includes(scale)&&['STRONG','SUPPORTIVE'].includes(growth)&&supportCount>=1)state='WATCH_10X_RESEARCH_PRIORITY';
  else if(scale==='SCALE_HEAVY')state='SCALE_CONSTRAINED';

  const reasons=[];
  if(scale==='STRONG_ROOM')reasons.push('Approximate market cap is at or below $1B, leaving substantial scale room.');
  else if(scale==='ROOM')reasons.push('Approximate market cap is between $1B and $5B.');
  else if(scale==='LIMITED_ROOM')reasons.push('Approximate market cap is between $5B and $15B; a 10x outcome would require much larger absolute scale.');
  else if(scale==='SCALE_HEAVY')reasons.push('Approximate market cap is above $15B; scale alone makes a 10x outcome materially harder.');
  else reasons.push('Approximate market cap is missing because verified price or SEC shares outstanding is unavailable.');

  if(growth==='STRONG')reasons.push('Forward consensus revenue growth is at least 30%.');
  else if(growth==='SUPPORTIVE')reasons.push('Forward consensus revenue growth is at least 15%.');
  else if(growth==='LOW')reasons.push('Forward consensus revenue growth is positive but below 15%.');
  else if(growth==='CONTRACTING')reasons.push('Forward consensus revenue growth is negative.');
  else reasons.push('Forward consensus revenue growth is missing.');

  if(cash==='SUPPORTIVE')reasons.push('Latest annual SEC free cash flow is positive.');
  if(quality==='STRONG'||quality==='SUPPORTIVE')reasons.push(`${qualitySupport}/${qualityObserved} observed Company Quality evidence signals are supportive.`);
  if(insider==='CLUSTER_SUPPORT')reasons.push('Multiple distinct insiders reported recent SEC Form 4 Code P purchases.');
  else if(insider==='RECENT_SUPPORT')reasons.push('At least one insider reported a recent SEC Form 4 Code P purchase.');

  return{
    status:missingCore?'REVIEW':'EVIDENCE',
    state,
    marketCapApprox:marketCap,
    price,
    sharesOutstanding:shares,
    sharesOutstandingAsOf:bundle?.secFinancials?.sharesOutstandingAsOf||null,
    forwardRevenueGrowthPct:revenueGrowth,
    analystCount,
    scale,
    growth,
    cash,
    quality,
    insider,
    qualitySupport,
    qualityObserved,
    supportCount,
    reasons,
    note:'10x Research is a prioritization filter, not a forecast, price target, trade signal or capital permission. Approximate market cap uses verified market price multiplied by SEC-reported shares outstanding.'
  };
}
